<template>
  <div>
    <div>
      <h5 v-html="(active+1) +'.'+ data[active].examCont+'（'+ data[active].scores+'分）'"></h5>
      <van-icon v-if="isdd && isdd !=null" color="red" name="success" /> <van-icon v-if="!isdd && isdd !=null" color="red" name="cross" />
      <!-- 单选 -->
      <van-radio-group v-if="!multiple" @change="checkda(data[active].examan,data[active].examansws,data[active].examTypeId,data[active])" v-model="data[active].examansws">
        <van-radio
          v-for="(m,n) in data[active].examop"
          :key="m.optionid"
          :name="m.optionid"
        >
          <span  v-html="capital[n]+'.&nbsp&nbsp'+m.optioncontent" ></span>
        </van-radio>

      </van-radio-group>
      <!-- 多选 -->
      <van-checkbox-group v-if="multiple" @change="checkda(data[active].examan,data[active].examansws,data[active].examTypeId,data[active])"  v-model="data[active].examansws">
        <van-checkbox
          v-for="(m,n) in data[active].examop"
          :key="m.optionid"
          shape="square"
          :name="m.optionid"
        >
          <span  v-html="capital[n]+'.&nbsp&nbsp'+m.optioncontent" ></span>
        </van-checkbox>
      </van-checkbox-group>
      <div style="padding: .625rem;"> <van-button type="warning" @click="ctrk(data[active].examInfoId)" v-if="!isdd && isdd !=null">收入错题库</van-button></div>
      <div @click="isda=true" v-if="!isda" style="padding: .625rem;">查看正确答案</div>
      <div v-if="isda"  style="height: 100px;width: 100%;padding: .625rem;"  >正确答案：<a v-for="(a,x) in data[active].examan" v-html="a.optioncontent"></a> </div>
      <div v-if="isda" style="height: 100px;width: 100%;padding: .625rem;"  >题目解析：<a v-html="data[active].gradestand"></a> </div>
      <div style="height: 100px;width: 100%" ></div>
    </div>
  </div>
</template>
<script>
import {Notify} from "vant";

export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    active: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      radio: '',
      activeIndex: 0,
      capital: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
      isda:false,
      isdd:null,
    }
  },
  methods: {
    changisda()
    {
      this.isda = false;
      this.isdd = null;
    },
    checkda(zqdan,dtdan,typeid,item)
    {
      if(typeid == '1' && dtdan != '' && dtdan!=null)
      {
        for (let i = 0; i < zqdan.length; i++) {
          if(zqdan[i].optionid == dtdan)
          {
            this.isdd = true;
            item.isdc = true;
          }
          else
          {
            this.isdd = false;
          }
        }
      }
      if((typeid == '2' || typeid == '7') && dtdan != '' && dtdan!=null) {
        let isd = 0
        for (let i = 0; i < zqdan.length; i++) {
          for (let j = 0; j < dtdan.length; j++) {
            if (zqdan[i].optionid == dtdan[j]) {
              isd++;
              continue;
            }
          }
        }
        if(dtdan.length == zqdan.length && isd==zqdan.length )
        {
          this.isdd = true;
          item.isdc = true;
        }
        else
        {
          this.isdd = false;
          item.isdc = false;
        }
      }
    },
    ctrk(examInfoid){
      this.$ajax.get('/student/lianxi/studentctrk/'+examInfoid).then(response => {
        Notify({ type: 'success', message: response.msg});
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/studentpage/lianxicomm/singleOpt.vue